import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import LayersIcon from '@mui/icons-material/Layers';

export interface EmptyStatePlotsProps {
  isSearchResult: boolean;
}

export const EmptyStatePlots: React.FC<EmptyStatePlotsProps> = ({
  isSearchResult,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 2,
        textAlign: 'center',
      }}
    >
      {isSearchResult ? (
        <SearchOffIcon
          sx={{
            fontSize: 64,
            color: 'text.disabled',
            mb: 2,
          }}
        />
      ) : (
        <LayersIcon
          sx={{
            fontSize: 64,
            color: 'text.disabled',
            mb: 2,
          }}
        />
      )}
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {isSearchResult ? 'No plots match your search' : 'No plots found'}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {isSearchResult
          ? 'Try adjusting your search terms.'
          : "This site doesn't have any plots yet."}
      </Typography>
    </Box>
  );
};
